/**
 * Shared team and player logos used across Trader, Matches, Games, Squares, etc.
 */
export { CricketTeamLogo, getOrderedCricketTeamLogoUrls, resolveCricketTeamLogoUrl } from "./CricketTeamLogo";
export { FootballTeamLogo } from "./FootballTeamLogo";
export { TennisPlayerImage } from "./TennisPlayerImage";
export { resolveFootballTeamLogoUrl, resolveFootballTeamLogoS3UrlsFromName } from "../../../utils/footballTeamLogoResolve";
export { resolveTennisPlayerImageUrl, resolveTennisPlayerImageS3UrlsFromName, splitTennisDoublesPlayerNames, isTennisDoublesPlayerName } from "../../../utils/tennisPlayerImageResolve";
export { getTennisDoublesPartners } from "../../../utils/tennisDoublesPartners";
export { PlayerHeadshotImage } from "./PlayerHeadshotImage";
export { HorsesJockeyImage } from "./HorsesJockeyImage";
